<template>
  <div v-if="dataisload" id="info-sidebar" class="product-info">
    <h1 class="product-name">{{ alldatas.Name }}</h1>
    <div class="item-wish">
      <a v-if="!selected.IsFavorite" href="#" @click.prevent="addToWish">
        <i class="icon-wish" />
      </a>
      <a v-else href="#" @click.prevent="removeWish">
        <i class="icon-wishactive" />
      </a>
    </div>

    <h3 class="product-subtitle">{{ alldatas.SubTitle }}</h3>
    <h3 class="product-price">
      <span class="sell-price">
        {{ currencyPrice(mapSellPrice) }}
      </span>
      <span
        v-if="alldatas.EventPrice > 0 || alldatas.SellPrice !== alldatas.OriginPrice"
        class="origin-price"
      >
        {{ currencyPrice(alldatas.OriginPrice) }}
      </span>
    </h3>
    <div v-if="selectedSpec !== null && selectedSpec.PreOrder" class="mb-3">
      {{ alldatas.ArrivalExplanation }}
    </div>
    <div class="product-color-wrap">
      <div class="selected-color">COLOR : {{ selected.Name }}</div>
      <div
        v-for="color in alldatas.Colors"
        :key="color.ID"
        class="product-color"
        :class="{ active: color.ID === selected.ID }"
        @click.prevent="changeImg(color.ID)"
      >
        <img :src="color.PintSizePictureUrl" />
      </div>
    </div>
    <p v-if="selectedSpec.Stock < 10 && selectedSpec.Stock > 0" class="text-danger my-2">
      即將售完
    </p>
    <div class="d-none d-lg-flex product-select-container">
      <div class="size-selector">
        <p class="mb-1">SIZE</p>
        <Selector
          :default-txt="'Select Size'"
          :options="selected.Specs"
          :selected="selectedSpec"
          @cb="selectSpec"
        />
      </div>
      <div class="count-selector">
        <p class="mb-1">Quantity</p>
        <Counter
          :default-txt="'數量'"
          :limit="counterOpts"
          :now-value="counter"
          @cb="handleCount"
        />
      </div>
    </div>
    <a
      :class="btnStyleGenerate"
      class="d-none d-lg-block btn mt-3 btn-add-cart"
      @click.prevent="addToCart"
    >
      {{ btnDescriptionGenerate }}
    </a>
    <div
      v-if="
        alldatas.Events.length !== 0 || alldatas.GiftEvents.length !== 0 || alldatas.Limit !== 0
      "
      class="product-event"
    >
      <div v-if="alldatas.Limit !== 0" class="py-1">此商品限購 {{ alldatas.Limit }} 件</div>
      <div v-for="(event, index) in alldatas.Events" :key="index" class="py-1">
        <a :href="'/campaign/' + event.ID">{{ event.Name }}</a>
      </div>
      <div v-for="(giftevent, index) in alldatas.GiftEvents" :key="index" class="py-1">
        <a :href="'/campaign/gift/' + giftevent.ID">{{ giftevent.Name }}</a>
      </div>
    </div>
    <ul class="list-collsape">
      <li>
        <a
          class="collapsed"
          data-toggle="collapse"
          href="#collapseDescription"
          role="button"
          aria-expanded="false"
          aria-controls="collapseDescription"
        >
          <span class="text-en">DESCRIPTION</span>
        </a>
        <div id="collapseDescription" class="collapse">
          <div class="py-3">
            <div class="mb-2" v-html="alldatas.Description" />
            <div class="mb-3" v-html="alldatas.MaterialDescription" />
            <p>產地: {{ alldatas.MaterialOriginDescription }}</p>
            <p>加工產地: {{ alldatas.OriginDescription }}</p>
          </div>
        </div>
      </li>
      <li>
        <a class="collapsed" href="#" @click.prevent="showSizeChart">
          <span class="text-en">VIEW SIZE GUIDE</span>
        </a>
      </li>
    </ul>
    <div v-if="dataisload" id="bottom-bar" class="d-lg-none">
      <a
        :data-custommarketid="alldatas.CustomMarketID"
        :data-colorid="alldatas.ColorID"
        href="#"
        :class="alldatas.IsPreShow ? 'btn-secondary disabled' : ''"
        class="open-dialog btn-add-cart btn"
        data-dialog="#dialog-market"
      >
        {{ alldatas.IsPreShow ? 'COMING SOON' : 'ADD TO BAG' }}
      </a>
    </div>
    <div class="d-none d-lg-block">
      <AddonShop :market-i-d="CustomMarketID" />
    </div>
  </div>
</template>

<script>
import $ from 'jquery';
import axios from 'axios';
import Selector from '@page/common/js/template/Select.vue';
import Counter from '@page/common/js/template/CountUI.vue';
import gtmTrace from '@global/components/tracing/gtm';
import AddonShop from '@page/shopContent/components/AddonShop.vue';
import utmKDetect from '@global/helpers/utmKDetect';
import { createNamespacedHelpers } from 'vuex';

import { fireAddToCart } from '@global/gtm/common';
import fireWishlistEvent from '@global/gtm/wishlist';

import AlertDialog from '@global/helpers/alertDialog';

const { mapActions } = createNamespacedHelpers('miniCartModule');

export default {
  name: 'SpecAPP',
  components: {
    Selector,
    Counter,
    AddonShop,
  },
  props: ['selected', 'alldatas', 'dataisload', 'hasstock'],
  data() {
    return {
      btndescription: {
        default: '請選擇尺寸',
        addCart: 'ADD TO BAG',
        soldout: 'SOLD OUT',
        preshow: 'COMING SOON',
        notice: '索取貨到通知',
      },
      selectedSpec: { Name: 'Select Size', Key: 'default', ID: 'default' },
      selectedSpecKey: null,
      counter: { Name: 1, Key: 1, ID: 'default' },
      btnStyle: 'disabled',
      btnDescription: '請選擇尺寸',
      isopen: false,
      windowHeight: 0,
      counterOpts: { Name: '數量', key: 'default', ID: 'default' },
      CustomMarketID: CustomMarketID.substring(0, CustomMarketID.indexOf('CL')),
    };
  },
  computed: {
    btnStyleGenerate: {
      get() {
        if (this.alldatas.IsPreShow) {
          this.btnStyle = 'disabled';
        }

        return this.btnStyle;
      },
      set(newVal) {
        this.btnStyle = newVal;
      },
    },
    btnDescriptionGenerate: {
      get() {
        if (this.alldatas.IsPreShow) {
          this.btnDescription = this.btndescription.preshow;
        }
        return this.btnDescription;
      },
      set(newVal) {
        this.btnDescription = newVal;
      },
    },
    mapSellPrice() {
      const price =
        this.alldatas.EventPrice > 0 && this.alldatas.EventPrice < this.alldatas.SellPrice
          ? this.alldatas.EventPrice
          : this.alldatas.SellPrice;
      return price;
    },
  },
  watch: {
    dataisload(val) {
      if (val && window.matchMedia('(min-width: 992px)').matches) {
        this.$nextTick(() => {
          $('#info-sidebar').stick_in_parent({ offset_top: 160 });
        });
      }
    },
    selected(val) {
      if (val.Specs.length === 1) {
        this.selectSpec(val.Specs[0]);
      }
    },
  },
  methods: {
    ...mapActions(['getCartInfo']),
    currencyPrice(price) {
      const currentCurrency = this.alldatas.CurrentCurrency;
      const priceString = price.toLocaleString();
      let combinePrice = '';
      if (currentCurrency === 'TWD') {
        combinePrice = `NT$ ${priceString}`;
      } else if (currentCurrency === 'USD') {
        combinePrice = `US$ ${priceString}`;
      } else {
        combinePrice = `${priceString}`;
      }
      return combinePrice;
    },
    addToWish() {
      const customMarketIDwithoutSZ = `${this.alldatas.CustomMarketID.substring(
        0,
        this.alldatas.CustomMarketID.indexOf('CL'),
      )}CL${this.selected.ID}SZ_`;

      axios
        .post(API_URL.FAVORITE, {
          CustomMarketID: customMarketIDwithoutSZ,
        })
        .then((res) => {
          if (res.data.Code === 200) {
            if (res.data.Response) {
              this.selected.IsFavorite = true;
              fireWishlistEvent({
                color: this.selected.Name,
                id: customMarketIDwithoutSZ,
                name: this.alldatas.Name,
                sellPrice: this.alldatas.SellPrice_TW,
                size: this.selectedSpec.Name || '',
              });
            }
          } else if (res.data.Code === 401) {
            AlertDialog.alert('請先登入');
          } else {
            AlertDialog.alert('系統忙線中');
          }
        })
        .catch((error) => {
          AlertDialog.alert(error);
        });
    },
    removeWish() {
      axios
        .delete(API_URL.FAVORITE, {
          data: {
            CustomMarketID: `${this.alldatas.CustomMarketID.substring(
              0,
              this.alldatas.CustomMarketID.indexOf('CL'),
            )}CL${this.selected.ID}SZ_`,
          },
        })
        .then((res) => {
          if (res.data.Code === 200) {
            if (res.data.Response) {
              this.selected.IsFavorite = false;
            }
          } else if (res.data.Code === 401) {
            AlertDialog.alert('請先登入');
          } else {
            AlertDialog.alert('系統忙線中');
          }
        })
        .catch((error) => {
          AlertDialog.alert(error);
        });
    },
    renderCounterOpts() {
      let maxCount = 20;

      if (this.alldatas.Limit !== 0) {
        maxCount = this.alldatas.Limit;
      } else {
        maxCount = this.selectedSpec.Stock < 20 ? this.selectedSpec.Stock : 20;
      }

      this.counterOpts = { Name: '數量', key: maxCount, ID: 'default' };
    },
    selectSpec(spec) {
      if (spec.key === 'default') {
        this.btnStyleGenerate = 'disabled';
        this.btnDescriptionGenerate = this.btndescription.default;
        this.clearSpec();
        this.resetCounter();
        return;
      }
      this.selectedSpec = spec;
      this.selectedSpecKey = spec.Key;
      this.resetCounter();
      this.getBtnStatus(spec.Stock, spec.IsOutOfStock, spec.PreOrder);
      this.renderCounterOpts();
    },
    clearSpec() {
      this.selectedSpec = { Name: 'Select Size', key: 'default' };
      this.selectedSpecKey = null;
      this.counterOpts = { Name: 'Quantity', key: 'default' };
    },
    handleCount(countObj) {
      this.counter = countObj;
    },
    resetCounter() {
      this.counter = { Name: 1, Key: 1 };
    },
    changeImg(colorID) {
      if (this.selected.ID === colorID) return;
      this.btnReset();
      this.clearSpec();
      this.resetCounter();

      this.$emit('change-slideindex', 0);
      this.$emit('change-selected', colorID);
    },
    getBtnStatus(stock, isSoldOut, isPreOrder) {
      if (this.alldatas.IsPreShow) return;
      if (stock === 0 && isSoldOut && !isPreOrder) {
        // 現貨無庫存且斷貨
        this.btnStyleGenerate = 'disabled';
        this.btnDescriptionGenerate = this.btndescription.soldout;
      } else if (stock === 0 && !isPreOrder) {
        // 現貨無庫存
        this.btnStyleGenerate = 'active-mail';
        this.btnDescriptionGenerate = this.btndescription.notice;
      } else if (stock === 0 && isPreOrder) {
        // 預購無庫存
        this.btnStyleGenerate = 'active-mail';
        this.btnDescriptionGenerate = this.btndescription.notice;
      } else {
        this.btnStyleGenerate = 'active';
        this.btnDescriptionGenerate = this.btndescription.addCart;
      }
    },
    btnReset() {
      this.btnStyleGenerate = 'disabled';
      this.btnDescriptionGenerate = this.btndescription.default;
    },
    addToCart() {
      const custommarketid = this.alldatas.CustomMarketID;
      const itemSpecInfo = `${custommarketid.substring(0, custommarketid.indexOf('CL'))}CL${
        this.selected.ID
      }SZ${this.selectedSpecKey}`;

      const utmData = utmKDetect(itemSpecInfo) === null ? '' : utmKDetect(itemSpecInfo);

      this.$emit('changecmid', itemSpecInfo);

      if (this.selectedSpec === null) {
        AlertDialog.alert('請選擇尺寸');
        return;
      }
      if (
        this.selectedSpec.Stock === 0 &&
        this.selectedSpec.IsOutOfStock &&
        !this.selectedSpec.PreOrder
      ) {
        return;
      }
      if (this.selectedSpec.Stock === 0) {
        $('#lb-get-product-mail').modal('show');
        return;
      }

      axios
        .post(API_URL.SHOPPING_CART, {
          CustomMarketID: itemSpecInfo,
          Count: this.counter.Key,
          UtmTag: utmData,
        })
        .then((res) => {
          if (res.data.Code === 200 || res.data.Code === 406) {
            this.checkisopen = false;
            this.getCartInfo();

            $('#cart-menu').toggleClass('active');
            $('.open-sideba').toggleClass('active');
            $('#cart-mask').toggleClass('active');
            if ($('.open-sideba').hasClass('active')) {
              $('body').addClass('lock-page');
            } else {
              $('body').removeClass('lock-page');
            }

            gtmTrace.addToCart({
              name: this.alldatas.Name,
              id: itemSpecInfo,
              price: this.alldatas.OriginPrice_TW,
              sale_price:
                this.alldatas.EventPrice_TW > 0 &&
                this.alldatas.EventPrice_TW < this.alldatas.SellPrice_TW
                  ? this.alldatas.EventPrice_TW
                  : this.alldatas.SellPrice_TW,
              color: this.selected.Name,
              count: this.counter,
            });

            fireAddToCart({
              item_id: itemSpecInfo.split('SZ')[0],
              item_name: this.alldatas.Name,
              index: 0,
              affiliation: this.selected.Name,
              item_brand: this.selectedSpec.Name,
              item_list_name: '產品內頁',
              price:
                this.alldatas.EventPrice_TW > 0 &&
                this.alldatas.EventPrice_TW < this.alldatas.SellPrice_TW
                  ? this.alldatas.EventPrice_TW
                  : this.alldatas.SellPrice_TW,
              quantity: this.counter.Key,
              item_variant: this.selectedSpec.Barcode,
            });
          } else if (res.data.Code === 400) {
            AlertDialog.alert(res.data.Message, () => {
              window.location.href = window.CategoryUrl;
            });
          } else {
            AlertDialog.alert(res.data.Message);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    showSizeChart() {
      $('#modal-sizechart').modal('show');
    },
  },
};
</script>
